import ExitBuilder from './ExitBuilder';
import BookName from './BookName';
import Help from './Help';

export default {
  components: {
    ExitBuilder,
    Help,
    BookName
  }
};
